export default __webpack_public_path__ + "static/media/scraping.4d857ac7.mp3";